import{useRef as r}from"react";import{deepCompareEqualsForMaps as e}from"./useDeepCompareMemoize.helpers.js";var t=function(t){var o=r();return e(t,o.current)||(o.current=t),o.current};export{t as useDeepCompareMemoize};
//# sourceMappingURL=useDeepCompareMemoize.js.map
